import {
  Bell,
  Briefcase,
  ChartBar,
  ChartLine,
  ClockCounterClockwise,
  Info,
  TrendUp,
  Compass,
  WaveSine,
} from 'phosphor-react';

export const getOptionsNavigationItems = (t) => [
  { key: 'dashboard', to: '/options', label: t('nav.dashboard'), Icon: Briefcase, match: (pathname) => pathname === '/options' || pathname === '/options/connect' },
  { key: 'positions', to: '/options/positions', label: t('nav.openPositions'), Icon: Briefcase, match: (pathname) => pathname.startsWith('/options/positions') },
  { key: 'outlook', to: '/options/outlook', label: t('nav.outlook') || 'BTC Outlook', Icon: Compass, match: (pathname) => pathname.startsWith('/options/outlook') },
  { key: 'gex', to: '/options/gex', label: 'GEX', Icon: WaveSine, match: (pathname) => pathname.startsWith('/options/gex') },
  { key: 'margin-volatility', to: '/options/margin-volatility', label: 'Margin × Vol', Icon: TrendUp, match: (pathname) => pathname.startsWith('/options/margin-volatility') },
  { key: 'volatility', to: '/options/volatility', label: 'Volatility', Icon: ChartLine, match: (pathname) => pathname.startsWith('/options/volatility') },
  { key: 'autopilot', to: '/options/autopilot', label: 'Options Autopilot', Icon: Compass, match: (pathname) => pathname.startsWith('/options/autopilot') },
  { key: 'history', to: '/options/history', label: t('nav.history'), Icon: ClockCounterClockwise, match: (pathname) => pathname.startsWith('/options/history') || pathname.startsWith('/options/operations') },
  { key: 'analytics', to: '/options/analytics', label: t('nav.analytics'), Icon: ChartBar, match: (pathname) => pathname.startsWith('/options/analytics') },
  { key: 'performance', to: '/options/performance', label: t('nav.performance'), Icon: TrendUp, match: (pathname) => pathname.startsWith('/options/performance') },
  { key: 'alerts', to: '/options/alerts', label: t('nav.alerts'), Icon: Bell, match: (pathname) => pathname.startsWith('/options/alerts') },
  { key: 'about', to: '/options/about', label: t('nav.about'), Icon: Info, match: (pathname) => pathname.startsWith('/options/about') },
];

export default getOptionsNavigationItems;
